export const validStatements: any = {
  'statement-1' : 'NO',
  'statement-2' : 'NO',
  'statement-3' : 'NO',
  'statement-4' : 'YES/NO',
  'statement-5' : 'NO',
  'statement-6' : 'NO',
  'statement-7' : 'NO',
  'statement-8' : 'NO',
  'statement-9' : 'YES/NO',
  'statement-10' : 'NO',
  'statement-11' : 'YES/NO',
  'statement-12' : 'YES/NO',
  'statement-13' : 'YES',
  'statement-14' : 'YES',
}

export const validateStatements = (statements: any) => {
  let isValid = true;

  Object.keys(statements).forEach((statement: any) => {
    if (validStatements[statement] !== 'YES/NO' && validStatements[statement] !== statements[statement]) {
      isValid = false;
      return false;
    }
  });

  return isValid;
}